export const BULK_JOB_ASSET_BATCH_SIZE = 100;

export const loadedBulkJobAssetBatches = (
    loadedAssetIds,
    batchSize = BULK_JOB_ASSET_BATCH_SIZE,
) => {
    const uniqueAssetIds = [...new Set((loadedAssetIds || []).filter(Boolean))];
    const batches = [];

    for(let index = 0; index < uniqueAssetIds.length; index += batchSize) {
        batches.push(uniqueAssetIds.slice(index, index + batchSize));
    }

    return batches;
};

export const refreshLoadedBulkJobAssets = async ({
    loadedAssetIds,
    requestAssets,
    applyAssets,
}) => {
    for(const assetIds of loadedBulkJobAssetBatches(loadedAssetIds)) {
        const assets = await requestAssets(assetIds);
        applyAssets(assets);
    }
};
